__turbopack_context__.v({
  "button-group": "LoginError-module-scss-module__nsPluG__button-group",
  "center-wrapper": "LoginError-module-scss-module__nsPluG__center-wrapper",
  "content": "LoginError-module-scss-module__nsPluG__content",
});
